var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_356",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4278",
    "data-name": "Rectangle 4278",
    width: 56.154,
    height: 51.547,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10447",
    "data-name": "Group 10447",
    transform: "translate(8.999 6.408)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6.41)",
    filter: "url(#Ellipse_356)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_356-2",
    "data-name": "Ellipse 356",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10272",
    "data-name": "Group 10272",
    transform: "translate(15.852 19.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10271",
    "data-name": "Group 10271",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44381",
    "data-name": "Path 44381",
    d: "M0,15.02a14.577,14.577,0,0,1,1.088-2.35A5.437,5.437,0,0,1,5.8,10.336c2.212-.014,4.424-.01,6.635-.014h.647c0-1.078-.04-2.1.011-3.115a16.763,16.763,0,0,1,.327-3.356A5.373,5.373,0,0,1,18.519,0Q34.45.009,50.38.051a5.56,5.56,0,0,1,5.713,4.73,5.371,5.371,0,0,1,.058.982q0,9.735,0,19.471a5.553,5.553,0,0,1-5.537,5.717c-.307.01-.614,0-1.007,0V39.6c0,.146,0,.293,0,.439.008.481-.065.928-.577,1.134a1.05,1.05,0,0,1-1.248-.42q-1.616-1.792-3.244-3.572c-.453-.5-.907-.993-1.416-1.55-.081.464-.117.857-.22,1.231A5.578,5.578,0,0,1,37.258,41.2q-7.376.035-14.751.029a1.137,1.137,0,0,0-.936.423q-4.078,4.519-8.18,9.017c-.135.149-.27.3-.408.444a.986.986,0,0,1-1.171.352,1.024,1.024,0,0,1-.6-1.07q0-4.223,0-8.447v-.707H9.414c-1.188,0-2.378-.039-3.564.008A5.616,5.616,0,0,1,.094,36.712.8.8,0,0,0,0,36.521V15.02M13.126,48.132c.226-.236.329-.339.427-.447q3.482-3.836,6.958-7.678a1.772,1.772,0,0,1,1.428-.642c5.1-.01,10.2-.088,15.3-.057a3.838,3.838,0,0,0,3.941-3.957q-.078-9.623,0-19.247a3.8,3.8,0,0,0-3.96-3.944q-15.707.064-31.414.077a3.805,3.805,0,0,0-3.933,3.975c.012,6.4,0,12.795.007,19.192a3.734,3.734,0,0,0,3.992,3.97c1.955,0,3.911,0,5.866,0,1.1,0,1.4.29,1.4,1.39q0,3.318,0,6.635v.731M47.718,37.86v-.694q0-3.373,0-6.745c0-1.043.3-1.351,1.327-1.353.4,0,.8,0,1.206,0a3.733,3.733,0,0,0,4.035-4.028q.005-9.542-.005-19.085a5.082,5.082,0,0,0-.159-1.3,3.6,3.6,0,0,0-3.668-2.7Q42.229,1.927,34,1.913C29,1.9,23.989,1.875,18.981,1.867A3.676,3.676,0,0,0,15.005,5.6C14.979,7.066,15,8.528,15,9.991a1.853,1.853,0,0,0,.062.325H15.8c7.311,0,14.622-.023,21.932.012a5.164,5.164,0,0,1,2.147.539,5.442,5.442,0,0,1,3.192,5.252c.016,5.374,0,10.749.013,16.123a1.142,1.142,0,0,0,.184.7c1.431,1.611,2.889,3.2,4.45,4.914",
    transform: "translate(0 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44382",
    "data-name": "Path 44382",
    d: "M50.473,111.829H62.146c.964,0,1.447.324,1.443.965s-.483.954-1.454.954q-11.673,0-23.346,0a3.109,3.109,0,0,1-.7-.071.913.913,0,0,1-.042-1.759,2.881,2.881,0,0,1,.756-.083q5.837-.007,11.673,0",
    transform: "translate(-28.953 -86.584)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44383",
    "data-name": "Path 44383",
    d: "M50.441,138.649q-5.918,0-11.836,0c-.786,0-1.217-.343-1.212-.95a.84.84,0,0,1,.719-.9,3.451,3.451,0,0,1,.707-.058q11.672,0,23.344,0a3.837,3.837,0,0,1,.492.02.966.966,0,0,1,.934.957.987.987,0,0,1-.982.922c-.327.025-.657.008-.986.008H50.441",
    transform: "translate(-28.951 -105.872)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44384",
    "data-name": "Path 44384",
    d: "M44.415,88.879c-1.954,0-3.908.005-5.862,0-.722,0-1.1-.288-1.159-.822a.9.9,0,0,1,.707-1.019,2.8,2.8,0,0,1,.651-.05q5.643,0,11.286,0A3.54,3.54,0,0,1,50.53,87a.983.983,0,0,1,.884.955.909.909,0,0,1-.919.9c-1.168.034-2.337.021-3.505.025-.859,0-1.717,0-2.575,0",
    transform: "translate(-28.947 -67.346)",
    fill: "#1a1818"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step_1.fa145479e8e750e242915adae77e957d.svg";
export { ForwardRef as ReactComponent };